<template>
  <F360ScreenFrame>
    <AnaliseInteligenteInsightsHeader
      @configure="handleOpenSettings"
      @dev-mode="handleOpenDevMode"
    />

    <AnaliseInteligenteInsightsInfoCallout />

    <div class="analise-inteligente-controls">
      <div class="filters">
        <div class="filters__selects">
          <F360Select
            v-model="analiseInteligente.filtros.IdDaEmpresa"
            :disabled="processando || !ativado"
            full
            style="width: 200px"
            :options="analiseInteligente.empresasOptions"
            placeholder="Selecione uma empresa"
          >
          </F360Select>

          <F360Select
            v-model="analiseInteligente.filtros.DataDeCompetencia"
            :disabled="processando || !ativado"
            full
            style="width: 180px"
            :options="analiseInteligente.periodosOptions"
            placeholder="Selecione um período"
          >
          </F360Select>
        </div>

        <F360RadioGroup
          v-model="analiseInteligente.filtros.analysisTypeModel"
          class="filters__analysis"
        >
          <el-radio
            v-for="option in agenteDeDreInsigthsStore.analysisOptions"
            :key="option.value"
            :value="option.value"
            :disabled="option.disabled || !ativado || processando"
          >
            {{ option.label }}
            <span v-if="option.tag" class="filters__analysis-tag">
              ({{ option.tag }})
            </span>
          </el-radio>
        </F360RadioGroup>
      </div>

      <F360Button
        filled
        prefix-icon="search"
        @click="handleBuscarRelatorio"
        :disabled="
          !ativado ||
          loading ||
          processando ||
          !analiseInteligente.filtros.IdDaEmpresa ||
          !analiseInteligente.filtros.DataDeCompetencia
        "
        style="margin-top: 16px"
      >
        Ver relatório
      </F360Button>
    </div>
  </F360ScreenFrame>

  <InsightConfiguracaoDialog
    v-model="isConfiguracaoDialogOpen"
    :tipo="ETipoConfiguracao.CONFIGURAR"
    :gerarRelatorio="false"
  />

  <InsightDevModeModal
    v-model="isDevModeModalOpen"
    :gateway="configuracaoGateway"
    :periodos="analiseInteligente.periodosOptions"
    :periodo-inicial="analiseInteligente.filtros.DataDeCompetencia"
    :modelo-inicial="idModeloDRE"
    @relatorio-excluido="handleRelatorioExcluido"
    @fecharModal="handleCloseDevModeModal"
  />
</template>

<script setup lang="ts">
import F360ScreenFrame from "@/ui/components/Layout/Main/ScreenFrame/F360ScreenFrame.vue";
import AnaliseInteligenteInsightsHeader from "./components/AnaliseInteligenteInsightsHeader.vue";
import AnaliseInteligenteInsightsInfoCallout from "./components/AnaliseInteligenteInsightsInfoCallout.vue";
import F360Button from "@/ui/components/Buttons/Button/F360Button.vue";
import F360Select from "@/ui/components/Select/Base/F360Select.vue";
import F360RadioGroup from "@/ui/components/Radios/RadioGroups/F360RadioGroup.vue";
import InsightConfiguracaoDialog from "../../../../widgets/configuracao/InsightConfiguracaoDialog.vue";
import InsightDevModeModal from "../../../../widgets/devMode/InsightDevModeModal.vue";
import { onMounted, ref } from "vue";
import { storeToRefs } from "pinia";
import { diContainer } from "@/inversify.config";
import {
  InsightConfiguracaoGateway,
  InsightConfiguracaoGatewayDi
} from "../../../../widgets/configuracao/services/InsightConfiguracaoGateway";
import { useAgenteDeDreInsigthsStore } from "../../store/useAgenteDeDreInsigthsStore";
import { ETipoConfiguracao } from "../../../../widgets/configuracao/types";

const isConfiguracaoDialogOpen = ref(false);
const isDevModeModalOpen = ref(false);

const agenteDeDreInsigthsStore = useAgenteDeDreInsigthsStore();
const { ativado, loading, analiseInteligente, processando, idModeloDRE } =
  storeToRefs(agenteDeDreInsigthsStore);

const configuracaoGateway = diContainer.get<InsightConfiguracaoGateway>(
  InsightConfiguracaoGatewayDi
);

const handleBuscarRelatorio = async () => {
  try {
    agenteDeDreInsigthsStore.setLoading(true);

    await agenteDeDreInsigthsStore.fetchBuscarRelatorio();
  } catch (error) {
    console.error(error);
  } finally {
    agenteDeDreInsigthsStore.setLoading(false);
  }
};

const handleOpenSettings = () => {
  isConfiguracaoDialogOpen.value = true;
};

const handleOpenDevMode = () => {
  isDevModeModalOpen.value = true;
};

const handleRelatorioExcluido = () => {
  agenteDeDreInsigthsStore.resetRelatorio(agenteDeDreInsigthsStore.relatorio);
};

const handleCloseDevModeModal = () => {
  isDevModeModalOpen.value = false;
  agenteDeDreInsigthsStore.fetchGetAgenteDeDre();
  handleBuscarRelatorio();
};

onMounted(() => {
  if (!analiseInteligente.value.empresasOptions.length) {
    agenteDeDreInsigthsStore.fetchGetAgenteDeDre();
  }
});
</script>

<style scoped lang="scss">
.analise-inteligente-controls {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;

  .filters {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    flex-wrap: wrap;
    margin: 16px 0 0;

    &__selects {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      flex-wrap: wrap;
    }

    &__analysis {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      flex-wrap: wrap;
    }
  }
}
</style>
